// ABOUTME: Translated labels of the job args the launch and schedule forms show, keyed by arg name.
// ABOUTME: An arg without a label falls back to the schema title, then to the humanized arg name.

import { defineMessages, MessageDescriptor, useIntl } from 'react-intl';

import { JobArgsSchema } from '../../types';

// Several ids are the ones the launch dialog used before the args became schema driven, so
// their existing translations keep working.
const messages = defineMessages({
    dryRun: {
        id: 'bom.dryRun.label',
        defaultMessage: 'Dry run - validate and report without writing',
    },
    disableOrphans: {
        id: 'importIdpUsers.disableOrphans.label',
        defaultMessage: 'Disable the users no longer in Keycloak',
    },
    fullReplaceMode: {
        id: 'objectSchemaImport.fullReplaceMode.label',
        defaultMessage:
            '⚠️ Full Replace Mode - This will DELETE all existing object schemas and replace them with the file contents',
    },
    isSemestral: { id: 'semestral-cat-import.label', defaultMessage: 'Semestrale' },
    modelCode: { id: 'importBom.modelCode.label', defaultMessage: 'Model code' },
    modelCodes: {
        id: 'pushBomPackage.modelCodes.label',
        defaultMessage: 'Model codes (comma separated)',
    },
    onlyRequestedModels: {
        id: 'pushBomPackage.onlyRequestedModels.label',
        defaultMessage:
            'Push only these models (the other models of the package are dropped from its BOM)',
    },
    hierarchyId: { id: 'launchJob.selectHierarchy', defaultMessage: 'Select a hierarchy' },
    fileName: { id: 'job.args.fileName', defaultMessage: 'File' },
    columnMappingFileName: {
        id: 'migrateDecisionTableCells.columnMapping.hint',
        defaultMessage:
            'Optional column-type mapping (JSON). Without it every column is migrated as text.',
    },
    nodeIds: { id: 'job.args.nodeIds', defaultMessage: 'Node ids (comma separated)' },
    retentionDays: { id: 'job.args.retentionDays', defaultMessage: 'Retention (days)' },
    shouldAlignPrices: { id: 'job.args.shouldAlignPrices', defaultMessage: 'Align prices' },
    shouldDraftPrototypes: {
        id: 'job.args.shouldDraftPrototypes',
        defaultMessage: 'Draft the prototypes',
    },
    force: { id: 'job.args.force', defaultMessage: 'Force' },
});

const FIELD_LABELS: Record<string, MessageDescriptor> = messages;

/** "retentionDays" -> "Retention days", "file_type" -> "File type". */
export const humanizeArgName = (name: string) => {
    const words = name
        .replace(/[_-]+/g, ' ')
        .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
        .trim()
        .toLowerCase();
    return words.charAt(0).toUpperCase() + words.slice(1);
};

export function useArgLabel() {
    const intl = useIntl();
    return (name: string, schema?: JobArgsSchema) => {
        const label = FIELD_LABELS[name];
        if (label) return intl.formatMessage(label);
        return schema?.title ?? humanizeArgName(name);
    };
}
